export const setCookie = ({
  name,
  value,
  expirationInDays,
  domain,
  path = '/',
}: {
  name: string;
  value: string;
  expirationInDays?: number;
  domain?: string;
  path?: string;
}) => {
  let cookie = `${name}=${value}; `;

  if (expirationInDays) {
    const expirationTime = expirationInDays * 24 * 60 * 60 * 1000;
    const date = new Date();
    const dateTimeNow = date.getTime();

    date.setTime(dateTimeNow + expirationTime);

    cookie = `${cookie} expires=${date.toUTCString()}; `;
  }

  if (domain) {
    cookie = `${cookie} domain=${domain}; `;
  }

  if (path) {
    cookie = `${cookie} path=${path}; `;
  }

  document.cookie = cookie.trim();
};
